import React from "react";
import { deleteUser } from "../../utils/api";

function DeleteConfirmModal({ show, onClose, userId, refresh, setBanner }) {
  if (!show) return null;

  const handleDelete = async () => {
    try {
      const res = await deleteUser(userId);

      if (res.success) {
        setBanner({
          type: "warning",
          message: res.message || "User deleted successfully.",
        });
        refresh();
        onClose();
      } else {
        setBanner({
          type: "danger",
          message: res.message || "Delete failed. Please try again.",
        });
      }
    } catch (err) {
      console.error("Delete user error:", err);
      setBanner({
        type: "danger",
        message: "Server error while deleting user.",
      });
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Confirm Delete</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to delete this user? This action cannot be
              undone.
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-danger" onClick={handleDelete}>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmModal;
